// extracted by mini-css-extract-plugin
export default {"checkbox-wrap":"CheckBox_checkbox-wrap__ZyGdp"};